import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Events } from 'ionic-angular';
import { User } from './user';
import { Storage } from '@ionic/storage';
/**
 * Import Firebase
 */
import { Fb } from './firebase';


@Injectable()
export class Task {
    public fb: any; // firebase
    public dayNames: any = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ];

    constructor(
        public http: Http,
        public events: Events,
        public user: User,
        public storage: Storage,
        public fire: Fb) {
        this.fb = fire.instance();
    }

    /**
     * Instance of database
     * 
     * @returns
     * 
     * @memberOf Task
     */
    db() {
        return this.fb.database();
    }
    /**
     * Path used as base reference for db
     * 
     * @returns Promise
     * 
     * @memberOf Task
     */
    ref() {
        return new Promise((resolve, reject) => {
            //resolve('tasks');
            //if (this.user.profile())
            resolve('/voucher'); //resolve('users/' + this.user.profile().uid + '/voucher');
        });
    }


    /**
     * Update total of tasks
     * 
     * 
     * @memberOf Task
     */
    countStats(): void {
        var stats = this.fb.database().ref('stats/voucher');
        stats.transaction(function (current) {
            return current + 1;
        });
    }

    /**
     * Save the task
     * 
     * @param {any} task
     * @returns Promise
     * 
     * @memberOf Task
     */
    save(task: any) {
        return new Promise((resolve, reject) => {
            if (task)
                this.ref().then((path) => {
                    if (task.id) { // updating = set
                        this.db().ref(path + '/' + task.id).set(task)
                            .then().catch(reject);
                    } else { // creating = push
                        delete task.id;
                        this.db().ref(path + '/').push(task)
                            .then((snap) => {
                                task.id = snap.key;
                            }).catch(reject);
                        this.countStats();
                    }
                    this.events.publish('task:saved', task);
                    resolve(task);
                });
            else
                reject('Missing task object');
        });
    }


    /**
     * Remove a Task
     * 
     * @param {string} id
     * @returns Promise
     * 
     * @memberOf Task
     */
    remove(id: string) {
        return new Promise((resolve, reject) => {
            this.ref().then((path) => {
                this.events.publish('task:removed');
                this.db().ref(path + '/' + id).remove().then().catch(reject);
                resolve(true);
            }, reject);
        });
    }

    prepare(snapshot: any) {
        
        debugger;
        if(this.user.profile() != null)
        {
            var uid = this.user.profile().uid;
            let tasks: any = [], _tasks: any = [], i = 0, snap = snapshot.val();
            for (let k in snap) {
                let task = {
                    id: k
                };
                Object.assign(task, snap[k]);
                debugger;
                if(snap[k].owner == this.user.profile().uid)
                _tasks.push(task);
            }

            tasks = _tasks;
            return tasks;
        }
    }

    dayName(entry) {
        return this.dayNames[entry];
    }


    getDayNames(entry) {
        let names: any = [];
        for (var k in entry) {
            if (entry[k])
                names.push(this.dayName(k).substr(0, 3));
        }
        return names.join(', ');
    }


    reorderByWeekDay(data, index) {
        return data.slice(index).concat(data.slice(0, index));
    }


    persist(tasks?: any) {
        //debugger;
        if (tasks)
            this.storage.set('firetask:task', JSON.stringify(tasks));
    }


}



// WEBPACK FOOTER //
// ./src/providers/task.ts